<template>
    <div>
        <button v-if="currentParent.length > 0"
            class="text-inherit bg-transparent border-none hover:opacity-75"
            @click="() => resetActions()">
            <i class="fas fa-reply"></i>
        </button>

        <div class="grid grid-cols-3 gap-x-5 w-full">
            <div
                class="shadow-lg cursor-pointer my-4 rounded-md text-left hover:outline hover:outline-1 hover:outline-gray-500"
                v-for="(action, index) in activeActions"
                @click="() => createAction(action)"
                :key="action.title + '-' + index"
                v-if="(currentParent.length > 0 && action.isChild) || (currentParent.length === 0 && !action.isChild)">
                <div class="font-bold">
                    <span>
                        <img v-if="action.image" :src="action.image" class="w-8 h-8"/>
                        <i v-else :class="action.icon" aria-hidden="true"></i>
                    </span>
                    {{ `${action.title} ${action.subTitle ? (" - " + action.subTitle) : ""}` }}
                    <span
                        v-show="isAdmin"
                        class="float-right ml-2 hover:opacity-75"
                        @click="(evt) => deleteAction(index, evt)">
                        <i class="fas fa-trash"></i>
                    </span>
                    <span v-show="isAdmin" class="float-right hover:opacity-75">
                        <i class="fas fa-edit" @click="(evt) => editAction(index, evt)"></i>
                    </span>
                </div>

                <div class="m-1 font-light">
                    {{ action.description }}
                </div>

            </div>
            <!-- Si admin -> flèche qui ouvre interface d'édition d'une step -->
            <div
                v-show="!stepEditorOpen && isAdmin"
                class="w-20 shadow-lg cursor-pointer my-4 rounded-md flex items-center align-center justify-center hover:outline hover:outline-1 hover:outline-gray-500"
                @click="() => stepEditorOpen = true">
                <i class="fas fa-plus fa-4x"></i>
            </div>
        </div>
        <action_editor
            v-show="stepEditorOpen"
            ref="actionEditor"
            :currentParent="currentParent"
            @cancelEdit="() => stepEditorOpen = false"
            @save-action="(newAction) => saveActionFromEditor(newAction)">

        </action_editor>
        <div v-show="serviceError" class=" text-red-500">
            {{ serviceError }}
        </div>
    </div>

</template>

<script>
	import {
		ActionListDescriptionsN1,
		ActionListDescriptionsN2,
	} from "../utils/liste_actions.js";
	import store from "../store.js";
	var clone = require("clone");

    import action_editor from "./action_editor.vue";
    import actionService from '../services/actions.js';

	export default {
        name: "choix_action_step",
        components: {
            action_editor,
        },
		data: function () {
			return {
				actions: [], // * toutes les actions
                currentParent: "",
                stepEditorOpen: false,
				user: null,

                serviceError: null
			};
		},
        computed: {
            activeActions: function() {
                let shownActions = this.actions;

                if (this.currentParent.length > 0) {
                    let parentAction = this.actions.find(action => action.title === this.currentParent);
                    if (parentAction) {
                        shownActions = parentAction.children ? parentAction.children : [];
                    }
                }
                return shownActions;
            },
            isAdmin: function() {
                return store.getters.isAdmin;
            }
        },
		methods: {
            deleteAction: async function(index, evt) {
                evt.stopPropagation();

                this.serviceError = null;

                if (this.currentParent.length > 0) {
                    // * find parent action
                    let parentAction = this.actions.find(action => action.title === this.currentParent);
                    // * remove action from children at index
                    parentAction.children.splice(index, 1);
                    let serviceRes = await actionService.Update(parentAction);
                    this.serviceError = serviceRes.err ? serviceRes.err : null;
                    return;
                } else {
                    var serviceRes = await actionService.Delete(this.actions[index]);

                    if (!serviceRes.err)
                        this.actions.splice(index, 1);
                    else
                        this.serviceError = serviceRes.err;
                }
            },
            handleSaveInParent: async function(action) {
                // * find parent
                let parent = this.actions.find(a => a.title === this.currentParent);

                if (parent.children === undefined)
                    parent.children = [];
                let existsInParent = parent.children.findIndex(a => a.title === action.title);
                if (existsInParent !== -1) {
                    parent.children[existsInParent] = action;
                } else {
                    // * changer le parent force activeActions à se recalculer
                    this.currentParent = "";
                    parent.children.push(action);
                    this.currentParent = parent.title;
                }

                var serviceRes = await actionService.Update(parent);
                return serviceRes;
            },
            saveActionFromEditor: async function(action) {
                let existingIndex = this.actions.findIndex(a => action.id !== undefined && a.id === action.id);

                var serviceRes = null;
                this.serviceError = null;

                if (this.currentParent.length > 0) {
                    serviceRes = await this.handleSaveInParent(action);
                } else {
                    if (existingIndex !== -1 && action.id !== undefined) {
                        serviceRes = await actionService.Update(action);
                    } else {
                        serviceRes = await actionService.Create(action);
                    }
                }
                console.log("Save result: ", serviceRes);
                if (serviceRes.err)
                    this.serviceError = serviceRes.err;
                
                // * les retour des updates n'ont pas l'id je trouve pas pourquoi...
                if (serviceRes.actionId === undefined && serviceRes.status !== 204)
                    this.serviceError = "Unknown error, no ID found";

                action.id = serviceRes.actionId === undefined ? action.id : serviceRes.actionId;
                if (serviceRes.status === 201)
                    this.actions.push(action);
                else if (serviceRes.status === 204)
                    this.actions[existingIndex] = action;

                this.stepEditorOpen = false;
            },
            editAction(idx, evt) {
                // * évite d'ouvrir l'action, on veut juste éditer la step
                evt.stopPropagation();
                // evt.preventDefault();

                this.stepEditorOpen = true;
                // * alimente le stepEditor avec l'action à éditer (utiliser une ref)
                this.$refs.actionEditor.loadEditor(this.activeActions[idx]);
            },
            async resetActions() {
                // * faire une requete au backend pour récupérer les actions
                // this.actions = ActionListDescriptionsN2();

                // console.log("Getting all actions: ", await actionService.GetAll());
                this.currentParent = "";
            },
			createAction: function (action) {
                // * permet d'afficher l'interface de création s'il n'y a pas de schémas ni d'enfant
                if ((action.children !== undefined && action.children.length > 0) || (action.schemas && action.schemas.length === 0)) {
                    this.currentParent = action.title;
                    return;
                } else {
                    this.currentParent = "";
                }

                console.log("User wants to create action: ", action);

				// * emit an event
				this.$emit("create-step", action);

                // * si on select une sous-action on peut remettre le menu au normal
                if (this.currentParent.length > 0)
        			this.resetActions();
			},
		},
		mounted: async function () {
            this.user = store.state.user;

			// * check les rules pour n1/n2
			// this.actions = ActionListDescriptionsN2();
            this.actions = await actionService.GetAll();
            if (this.actions === null)
                this.actions = [];
            this.actions = this.actions.map(action => {
                action.schemas = action.action_schemas;
                delete action.action_schemas;
                return action;
            });

            // this.resetActions();
		},
	};
</script>
